var map = {
	"./Analytics.vue": 37770,
	"./BoxIiotDashboard.vue": 145,
	"./BoxInfo.vue": 98651,
	"./Boxes.vue": 43863,
	"./EventsPage.vue": 2096,
	"./ForgotPassword/ActivationPassword.vue": 69490,
	"./ForgotPassword/ConfirmPassword.vue": 32829,
	"./ForgotPassword/ResetPassword.vue": 18067,
	"./Login.vue": 63323,
	"./Maintenance.vue": 19578,
	"./Market.vue": 62433,
	"./SensorsAR.vue": 72699,
	"./Settings.vue": 67854,
	"./market/Boxes.vue": 69861,
	"./market/FeatureDetails.vue": 72917,
	"./market/Features.vue": 95894,
	"./registration/CreatingCompany.vue": 82794,
	"./registration/Register-many.vue": 27303,
	"./registration/Register.vue": 12416,
	"./registration/RegisterCompany.vue": 4906,
	"./registration/VerifyEmail.vue": 22668,
	"./settings/AddBox.vue": 94827,
	"./settings/ApiSettings.vue": 66427,
	"./settings/Billing.vue": 14152,
	"./settings/BoxEdit.vue": 7466,
	"./settings/BoxView.vue": 50095,
	"./settings/Faq.vue": 60918,
	"./settings/Profile.vue": 38979,
	"./settings/Requests.vue": 68063,
	"./support/BotLinks.vue": 84461
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94997;